import { RouteObject } from "react-router-dom";
import RecipientListLanding from "./landing/landing";
import CreateRecipientList from "./create/create";
import RecipientListDetailsLanding from "./details/landing/landing";

export interface uxRecipientListRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxRecipientListRoute[];
}

export const uxRecipientListRoutes: uxRecipientListRoute[] = [
  {
    path: "communication-hub/recipient-list",
    element: <RecipientListLanding />,
  },
  {
    path: "communication-hub/recipient-list/:action",
    element: <CreateRecipientList />,
  },
  {
    path: "communication-hub/recipient-list/:action/:id/:name",
    element: <CreateRecipientList />,
  },
  {
    path: "communication-hub/recipient-list/view/:id/:name",
    element: <RecipientListDetailsLanding />,
  },
];
